import { createSlice } from '@reduxjs/toolkit';

// ** Initial State
const initialState = {
  original2BData: [],
  bills: [],
  period: ''
};

// ** Reducer
const original2BData = createSlice({
  name: 'original2BData',
  initialState,
  reducers: {
    setOriginal2BData: (state, action) => {
      state.original2BData = action.payload;
    },
    setBills: (state, action) => {
      state.bills = action.payload;
    },
    setPeriod: (state, action) => {
      state.period = action.payload;
    }
  }
});

export const { setOriginal2BData, setBills, setPeriod } =
  original2BData.actions;

export default original2BData.reducer;
